"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TreeStyles = exports.StyledTreeContainer = exports.StyledSearchTree = void 0;
var _react = _interopRequireWildcard(require("react"));
var _ykbStyledComponents = _interopRequireWildcard(require("../ykb-styled-components"));
var _StyledTextInput = require("../TextInput/StyledTextInput");
var _StyledIcon = _interopRequireDefault(require("../Icon/StyledIcon"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var TreeStyles = exports.TreeStyles = (0, _ykbStyledComponents.createGlobalStyle)([".", "{margin:", ";padding:", ";.", "-list-holder-inner{align-items:flex-start;.editable-icons-wrapper{.ykb-icon{margin-left:5px;&:hover{cursor:pointer;}&.add,&.edit{color:", ";&:hover{color:", ";}}&.remove{color:", ";&:hover{color:", ";}}}}}&-treenode{outline:0;display:flex;margin-bottom:", ";align-items:center;.draggable{color:", ";user-select:none;-khtml-user-drag:element;-webkit-user-drag:element;}&.drag-over{> .draggable{background-color:", ";color:", ";border:1px ", " solid;opacity:1;}}&.drag-over-gap-top{> .draggable{border-top:", ";}}&.drag-over-gap-bottom{> .draggable{border-bottom:", ";}}.", "-indent{align-self:stretch;white-space:nowrap;user-select:none;.", "-indent-unit{width:", ";display:inline-block;position:relative;height:100%;", "}}.", "-node-content-wrapper{position:relative;z-index:auto;display:inline-block;margin:0;padding:", ";color:inherit;border-radius:2px;cursor:pointer;transition:all 0.3s,border 0s,line-height 0s,box-shadow 0s;line-height:", ";font-size:", ";color:", ";.", "-title{}.", "-title + div{background:transparent !important;}&:hover{background-color:", ";}}span{&.", "-switcher,&.", "-checkbox,&.", "-iconEle{line-height:", ";display:inline-block;vertical-align:middle;border:0 none;cursor:pointer;outline:none;background-repeat:no-repeat;background-attachment:scroll;border:1px solid;margin-right:", ";text-align:center;}&.", "-iconEle-rightIcon{margin-left:", ";}&.", "-iconEle{line-height:0;border:0px;", "{vertical-align:middle;font-size:", ";height:100%;margin:0 auto;}}&.", "-icon_loading{vertical-align:top;background:url('data:image/gif;base64,R0lGODlhEAAQAKIGAMLY8YSx5HOm4Mjc88/g9Ofw+v///wAAACH/C05FVFNDQVBFMi4wAwEAAAAh+QQFCgAGACwAAAAAEAAQAAADMGi6RbUwGjKIXCAA016PgRBElAVlG/RdLOO0X9nK61W39qvqiwz5Ls/rRqrggsdkAgAh+QQFCgAGACwCAAAABwAFAAADD2hqELAmiFBIYY4MAutdCQAh+QQFCgAGACwGAAAABwAFAAADD1hU1kaDOKMYCGAGEeYFCQAh+QQFCgAGACwKAAIABQAHAAADEFhUZjSkKdZqBQG0IELDQAIAIfkEBQoABgAsCgAGAAUABwAAAxBoVlRKgyjmlAIBqCDCzUoCACH5BAUKAAYALAYACgAHAAUAAAMPaGpFtYYMAgJgLogA610JACH5BAUKAAYALAIACgAHAAUAAAMPCAHWFiI4o1ghZZJB5i0JACH5BAUKAAYALAAABgAFAAcAAAMQCAFmIaEp1motpDQySMNFAgA7') no-repeat scroll 0 0 transparent;}&.", "-switcher{width:", ";height:", ";position:relative;border:0;&.", "-switcher-noop{cursor:auto;}&.", "-switcher_open{&:after{width:0;height:0;border-left:", " solid transparent;border-right:", " solid transparent;border-top:", " solid ", ";content:'';position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);}}&.", "-switcher_close{&:after{width:0;height:0;border-top:", " solid transparent;border-bottom:", " solid transparent;border-left:", " solid ", ";content:' ';position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);}}}&.", "-checkbox{width:", ";height:", ";margin-right:", ";border-radius:", ";border-color:", ";background-position:0 0;position:relative;&:hover{border-color:", ";}&-checked{border-color:", ";&:after{position:absolute;left:50%;top:45%;transform:translate(-50%,-50%) rotate(45deg);display:table;width:", ";height:", ";border:2px solid ", ";border-top:0;border-left:0;content:' ';}}&-indeterminate{&:after{position:absolute;width:10px;height:10px;top:50%;left:50%;transform:translate(-50%,-50%);border-radius:1px;background-color:", ";content:' ';}}&.", "-checkbox-disabled{background:", ";border-color:", ";&::after{content:' ';border-color:", ";}+ .", "-node-content-wrapper:hover{background:transparent;}}}}}&-treenode-disabled{> span,> a,> a span{color:", " !important;cursor:not-allowed !important;}}&-node-selected{background-color:", " !important;border:", " !important;opacity:", " !important;}}"], function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.tree.containerMargin;
}, function (props) {
  return props.theme.tree.containerPadding;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.color.primary6;
}, function (props) {
  return props.theme.color.primary7;
}, function (props) {
  return props.theme.color.default6;
}, function (props) {
  return props.theme.color.default7;
}, function (props) {
  return props.theme.tree.treeItem.childTreeMarginBottom;
}, function (props) {
  return props.theme.tree.draggable.target.defaultTextColor;
}, function (props) {
  return props.theme.tree.draggable.target.onDragBackgroundColor;
}, function (props) {
  return props.theme.tree.draggable.target.onDragTextColor;
}, function (props) {
  return props.theme.tree.draggable.target.onDragBorderColor;
}, function (props) {
  return props.theme.tree.draggable.target.dragPointerBorder;
}, function (props) {
  return props.theme.tree.draggable.target.dragPointerBorder;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.tree.treeItem.indentWidth;
}, function (props) {
  return props.showLine && (0, _ykbStyledComponents.css)(["&:before{position:absolute;top:-3px;right:11px;bottom:-3px;border-right:1px solid ", ";content:'';}&-start:before{content:'' !important;display:block;}&-end:before{display:none;}"], function (props) {
    return props.theme.tree.line.color;
  });
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.tree.treeItem.textPadding;
}, function (props) {
  return props.theme.tree.treeItem.lineHeight;
}, function (props) {
  return props.theme.tree.treeItem.fontSize;
}, function (props) {
  return props.theme.tree.treeItem.textColor;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.tree.treeItem.hoverBackgroundColor;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.tree.toggleIcon.lineHeight;
}, function (props) {
  return props.theme.tree.checkbox.marginRight;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.tree.checkbox.marginLeft;
}, function (props) {
  return props.prefixCls;
}, _StyledIcon.default, function (props) {
  return props.theme.tree.customIcon.size;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.tree.toggleIcon.width;
}, function (props) {
  return props.theme.tree.toggleIcon.height;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.tree.toggleIcon.iconWidth;
}, function (props) {
  return props.theme.tree.toggleIcon.iconWidth;
}, function (props) {
  return props.theme.tree.toggleIcon.iconWidth;
}, function (props) {
  return props.theme.tree.toggleIcon.iconColor;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.tree.toggleIcon.iconWidth;
}, function (props) {
  return props.theme.tree.toggleIcon.iconWidth;
}, function (props) {
  return props.theme.tree.toggleIcon.iconWidth;
}, function (props) {
  return props.theme.tree.toggleIcon.iconColor;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.tree.checkbox.width;
}, function (props) {
  return props.theme.tree.checkbox.height;
}, function (props) {
  return props.theme.tree.checkbox.marginRight;
}, function (props) {
  return props.theme.tree.checkbox.borderRadius;
}, function (props) {
  return props.theme.tree.checkbox.borderColor;
}, function (props) {
  return props.theme.tree.checkbox.checkedBorderColor;
}, function (props) {
  return props.theme.tree.checkbox.checkedBorderColor;
}, function (props) {
  return props.theme.tree.checkbox.iconWidth;
}, function (props) {
  return props.theme.tree.checkbox.iconHeight;
}, function (props) {
  return props.theme.tree.checkbox.checkedBorderColor;
}, function (props) {
  return props.theme.tree.checkbox.checkedBorderColor;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.tree.treeItem.disabled.backgroundColor;
}, function (props) {
  return props.theme.tree.checkbox.borderColor;
}, function (props) {
  return props.theme.tree.treeItem.disabled.checkColor;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.tree.treeItem.disabled.textColor;
}, function (props) {
  return props.theme.tree.draggable.source.backgroundColor;
}, function (props) {
  return props.theme.tree.draggable.source.border;
}, function (props) {
  return props.theme.tree.draggable.source.opacity;
});
var Container = function Container(_ref) {
  var prefixCls = _ref.prefixCls,
    children = _ref.children,
    theme = _ref.theme,
    className = _ref.className,
    showLine = _ref.showLine;
  // last classname what we need
  var prefix = prefixCls ? prefixCls : className.split(' ').pop();
  return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(TreeStyles, {
    theme: theme,
    prefixCls: prefix,
    showLine: showLine
  }), children(prefix));
};
var StyledTreeContainer = exports.StyledTreeContainer = (0, _ykbStyledComponents.default)(Container).withConfig({
  componentId: "ykb-ui__sc-jz1ysq-0"
})([""]);
var StyledSearchTree = exports.StyledSearchTree = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-jz1ysq-1"
})(["display:inline-block;", "{border-radius:", ";}.search-tree{padding:10px 0px;}span.text{}span.match{color:", ";}"], _StyledTextInput.StyledInput, function (props) {
  return props.theme.borderRadiusBase;
}, function (props) {
  return props.theme.color.danger6;
});